import { lazy } from 'react';
import { templates } from 'assets/templates';

const multiLazy = (lazyTemplates: string[]) =>
  lazyTemplates.map(name => lazy(() => import(`../components/templates/${name}`)));

const [
  TemplateSimple,
  TemplateLight,
  TemplateLandscape,
  TemplateBrandPromoter,
  TemplateBusinessOwners,
  TemplateGeneralPractitioner,
  TemplateOne,
  TemplateTwo,
  TemplateThree,
  TemplateFour,
] = multiLazy([
  'templateSimple',
  'templateLight',
  'templateLandscape',
  'templateBrandPromoter',
  'templateBusinessOwners',
  'templateGeneralPractitioner',
  'templateOne',
  'templateTwo',
  'templateThree',
  'templateFour',
]);

export const templateList = [
  {
    value: 'simple',
    src: templates['template_simple.png'],
    name: 'Simple',
    component: TemplateSimple,
  },
  {
    value: 'light',
    src: templates['template_light.png'],
    name: 'Light',
    component: TemplateLight,
  },
  {
    value: 'landscape',
    src: templates['template_landscape.png'],
    name: 'Landscape',
    component: TemplateLandscape,
  },
  {
    value: 'brand_promoter',
    src: templates['template_brand_promoter.png'],
    name: 'Brand Promoter',
    component: TemplateBrandPromoter,
  },
  {
    value: 'business_owners',
    src: templates['template_business_owners.png'],
    name: 'Business Owners',
    component: TemplateBusinessOwners,
  },
  {
    value: 'general_practitioner',
    src: templates['template_general_practitioner.png'],
    name: 'General Practitioner',
    component: TemplateGeneralPractitioner,
  },
  {
    value: 'template1',
    src: templates['Template1.svg'],
    name: 'Template 1',
    component: TemplateOne,
  },
  {
    value: 'template2',
    src: templates['Template2.svg'],
    name: 'Template 2',
    component: TemplateTwo,
  },
  {
    value: 'template3',
    src: templates['Template3.svg'],
    name: 'Template 3',
    component: TemplateThree,
  },
  {
    value: 'template4',
    src: templates['Template4.svg'],
    name: 'Template 4',
    component: TemplateFour,
  },
];

export const meetingTemplateList = [
  { value: 'template1', name: 'Template 1' },
  { value: 'template2', name: 'Template 2' },
  { value: 'template3', name: 'Template 3' },
];
